import { useState, useRef, useLayoutEffect, useEffect } from 'react'

import classNames from 'classnames'

import styles from './scroll_animation.module.sass'

function ScrollAnimation(props) {
	const inheritedStyles = props.styles
	const ref = useRef()
	const [visibleIn, setVisibleIn] = useState(0)
	const [rendered, setRendered] = useState(0)

	const isMobile = () => {
		if (Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 768){
			return true
		}

		return false
	}

	const threshold = isMobile() ? 0.01 : 0.01


	useEffect(() => {
		const observer = new IntersectionObserver(
		([entry]) => {
			// Update our state when observer callback fires
			setVisibleIn(entry.isIntersecting)

			if(entry.isIntersecting){
				observer.unobserve(entry.target)

				setTimeout(() => {
					setRendered(1)
				}, 1)
			}
		},
		{
			threshold: threshold,
			rootMargin: '0px'
		}
	)

	if (ref.current) {
		observer.observe(ref.current)
	}

	return () => {
		observer.unobserve(ref.current)
	}
	}, [])
  

	return <div ref={ref} className={classNames(styles.scroll_animation, inheritedStyles.scroll_animation, visibleIn ? inheritedStyles.animate_in : '', rendered ? props.styles.rendered : '')}>{props.children}</div>
}

export default ScrollAnimation